import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import { GetCaseQuery, GetCaseQueryVariables } from "src/graphql/anti-fraud/__generated__/graphql";
import { alertSummaryFragment } from "src/graphql/anti-fraud/fragments/AlertSummaryFragment";
import { caseFragment } from "src/graphql/anti-fraud/fragments/CaseFragment";
import { caseSummaryFragment } from "src/graphql/anti-fraud/fragments/CaseSummaryFragment";
import { scenarioExecutionResultWithCaseFragment } from "src/graphql/anti-fraud/fragments/ScenarioExecutionResultWithCaseFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToAlertSummary } from "src/mappers/alert.mappers";
import { mapToCase, mapToCaseSummary } from "src/mappers/case.mappers";
import { mapToScenarioExecutionResultWithCase } from "src/mappers/scenario.mappers";

export const getCaseByIdQuery = gql`
  query GetCase($id: ID!) {
    case(id: $id) {
      ...CaseFragment
      alerts {
        ...AlertSummaryFragment
      }
      executionResults {
        ...ScenarioExecutionResultWithCaseFragment
      }
      source {
        ...CaseSummaryFragment
      }
    }
  }

  ${scenarioExecutionResultWithCaseFragment}
  ${caseFragment}
  ${alertSummaryFragment}
  ${caseSummaryFragment}
` as TypedDocumentNode<GetCaseQuery, GetCaseQueryVariables>;

export const useGetCaseByIdQuery = (
  options: QueryHookOptions<GetCaseQuery, GetCaseQueryVariables>
) => {
  return useFetchQuery(getCaseByIdQuery, {
    toData: (data) => {
      if (!data?.case) return null;

      return {
        ...mapToCase(data.case),
        alerts: data.case.alerts.map(mapToAlertSummary),
        executionResults: data.case.executionResults.map(mapToScenarioExecutionResultWithCase),
        source: data.case.source ? mapToCaseSummary(data.case.source) : null,
      };
    },
    isEmpty: (data) => !data?.case,
    queryOptions: options,
    uiErrors: {
      fetchError: "FETCH-CASES-ERROR",
    },
  });
};
